import React, { useEffect } from 'react';
import styled from 'styled-components';

const bannerHeight = '100px';

const BannerImage = styled.img`
  width: auto;
  min-width: 185px;
  height: ${bannerHeight};
  border-radius: 10px 0px 0px 10px;
  background-color: white;
  max-width: 100%;
`;

const TextWrapper = styled.div`
  height: ${bannerHeight};
  padding-left: 40px;
  border-radius: 0px 10px 10px 0px;
  background-color: white;
  width: 100%;
`;

const Text = styled.div`
  padding-top: 16px;
  font-size: 26px;
  font-weight: 500;
`;

const SubText = styled.div`
  padding-top: 10px;
  font-size: 16px;
  opacity: 0.8;
  color: #333333;
`;

const TopBanner = ({
  receivedAllChunks,
  bannerDetails,
  hasBannerData,
  bannerDisplayPdtHandler = null,
  bannerClickPdtHandler = null,
  pushAnalyticsData
}) => {
  useEffect(() => {
    if (bannerDisplayPdtHandler && hasBannerData) {
      bannerDisplayPdtHandler(bannerDetails.ti || '');
    }
  }, []);

  let bannerLink = 'https://www.goibibo.com/info/gosafe/';
  let bannerImgLink = 'https://gos3.ibcdn.com/gosafesrp-1590147458.png';
  let linkTarget = '_blank';

  if (hasBannerData) {
    bannerLink = bannerDetails.lu;
    bannerImgLink = bannerDetails.iu;
    linkTarget = bannerDetails.lu ? '_blank' : '';
  }

  const bannerClickHandler = url => {
    if (bannerClickPdtHandler) {
      bannerClickPdtHandler(bannerDetails.ti || '');
    }

    pushAnalyticsData({
      pageType: 'SRP',
      eventName: 'specialFareBanner',
      data: { destination: url }
    });
    if (!url || url === '') {
      return;
    }
    if (linkTarget === '_blank') {
      window.open(url, linkTarget);
    } else {
      window.location.href = url;
    }
  };

  if (!receivedAllChunks) {
    return <div></div>;
  }

  return (
    <div className="clr fGS0 padB10">
      <a
        onClick={() => {
          bannerClickHandler(bannerLink);
        }}
        className="width100 flexRow"
      >
        <BannerImage src={bannerImgLink} width="185.413px" />
        {hasBannerData ? (
          <TextWrapper>
            <Text className="black">{bannerDetails.t}</Text>
            <SubText>{bannerDetails.st}</SubText>
          </TextWrapper>
        ) : null}
      </a>
    </div>
  );
};

export default TopBanner;
